module.exports = __webpack_public_path__ + "img/Metamorphose.216c1429.jpg";